import { Type } from '@sinclair/typebox';
import { baseCommandSchema } from "./shared.mjs";
export const addCustomStickerLineItemCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('addCustomStickerLineItem'),
        customStickerId: Type.String(),
        quantity: Type.Optional(Type.Number({ minimum: 1 })),
    }),
]);
export const addStickerShopLineItemCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('addStickerShopLineItem'),
        stickerShopItemId: Type.Number(),
        quantity: Type.Optional(Type.Number({ minimum: 1 })),
    }),
]);
export const addStickerPackLineItemCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('addStickerPackLineItem'),
        stickerPackId: Type.Number(),
        quantity: Type.Optional(Type.Number({ minimum: 1 })),
    }),
]);
export const addGiftCardLineItemCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('addGiftCardLineItem'),
        name: Type.String(),
        imageUrl: Type.String(),
        quantity: Type.Optional(Type.Number({ minimum: 1 })),
        figureId: Type.String(),
    }),
]);
export const duplicateCustomStickerLineItemCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('duplicateCustomStickerLineItem'),
        /** The line item you want to duplicate */
        lineItemId: Type.String(),
        quantity: Type.Optional(Type.Number()),
    }),
]);
export const removeLineItemCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('removeLineItem'),
        lineItemId: Type.String(),
    }),
]);
export const updateLineItemCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('updateLineItem'),
        lineItemId: Type.String(),
        quantity: Type.Number(),
    }),
]);
export const addLinesFromOrderCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('addLinesFromOrder'),
        orderId: Type.String(),
        sheetIds: Type.Optional(Type.Array(Type.String())),
        email: Type.Optional(Type.String()),
        transactionId: Type.Optional(Type.String()),
        discountCode: Type.Optional(Type.String()),
        isReorder: Type.Optional(Type.Boolean()),
    }),
]);
export const createCartFromManualOrderCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('createCartFromManualOrder'),
        orderId: Type.String(),
        sheetIds: Type.Optional(Type.Array(Type.String())),
        email: Type.Optional(Type.String()),
        transactionId: Type.Optional(Type.String()),
        discountCode: Type.Optional(Type.String()),
    }),
]);
//# sourceMappingURL=lineItem.js.map